export const messages = {
  en: {
    carInoutManage: {
      searchCondition: 'Search Condition',
      carNumRequired: 'Required, please enter license plate number',
      selectCarStatus: 'Select vehicle status',
      inStatus: 'Entry Status',
      payCompleted: 'Payment Completed',
      outStatus: 'Exit Status',
      payTimeout: 'Payment Timeout',
      selectCarType: 'Select license plate type',
      temporaryCar: 'Temporary Car',
      saleCar: 'Sale Car',
      monthlyCar: 'Monthly Car',
      internalCar: 'Internal Car',
      freeCar: 'Free Car',
      startTimePlaceholder: 'Please enter start time',
      endTimePlaceholder: 'Please enter end time',
      query: 'Search',
      reset: 'Reset',
      carInoutRecord: 'In/Out Records',
      inPhoto: 'Entry Photo',
      inoutId: 'In/Out ID',
      carStatus: 'Vehicle Status',
      carNum: 'License Plate',
      parkingArea: 'Parking Area',
      feeRule: 'Billing Rule',
      carType: 'License Type',
      inTime: 'Entry Time',
      outTime: 'Exit Time',
      parkingTime: 'Parking Duration',
      chargeAmount: 'Charge Amount',
      remark: 'Remark',
      hour: 'hour',
      minute: 'min',
      out: 'Exit'
    }
  },
  zh: {
    carInoutManage: {
      searchCondition: '查询条件',
      carNumRequired: '必填，请填写车牌号',
      selectCarStatus: '请选择车辆状态',
      inStatus: '进场状态',
      payCompleted: '支付完成',
      outStatus: '离场状态',
      payTimeout: '支付超时重新支付',
      selectCarType: '请选择车牌类型',
      temporaryCar: '临时车',
      saleCar: '出售车辆',
      monthlyCar: '月租车',
      internalCar: '内部车',
      freeCar: '免费车',
      startTimePlaceholder: '请填写开始时间',
      endTimePlaceholder: '请填写结束时间',
      query: '查询',
      reset: '重置',
      carInoutRecord: '进出场记录',
      inPhoto: '进场图',
      inoutId: '进出场编号',
      carStatus: '车辆状态',
      carNum: '车牌号',
      parkingArea: '停车场',
      feeRule: '计费规则',
      carType: '车牌类型',
      inTime: '进场时间',
      outTime: '出场时间',
      parkingTime: '停车时间',
      chargeAmount: '收费金额',
      remark: '说明',
      hour: '小时',
      minute: '分',
      out: '出场'
    }
  }
}